import React from 'react';

export default class Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToTakeResponsibility');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToTakeControl')}
                                                        className="link_color task button-link-redirect">How to take control</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDevelopStrategicLongTermGoals')}
                                                        className="link_color task button-link-redirect">How to develop strategic
                                                        long-term goals</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToFocusOnTheBiggerPicture')}
                                                        className="link_color task button-link-redirect">How to focus on the bigger
                                                        picture</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBalanceRiskWithPotentialBenefits')}
                                                        className="link_color task button-link-redirect">How to balance risk with
                                                        potential benefits</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBeConfidentInYourJudgementCalls')}
                                                        className="link_color task button-link-redirect">How to be confident in
                                                        making judgement calls</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMakeTimelyDecisions')}
                                                        className="link_color task button-link-redirect">How to make timely
                                                        decisions</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDelegate')}
                                                        className="link_color task button-link-redirect">How to delegate.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Darley, J. &amp; Latané,
                                                    B. (1968). Bystander intervention in emergencies: Diffusion
                                                    of responsibility.
                                                    <span className="subtiltereg">Journal of Personality and Social Psychology,</span> 8,
                                                    377-383.</p></li>
                                                <li><p className="further_info_content">Liden, R. C., Wayne, S.
                                                    J., Jaworski, R. A., &amp; Bennett, N. (2004). Social
                                                    loafing: A field investigation.
                                                    <span
                                                        className="subtiltereg">Journal of Management,</span> 30(2),
                                                    285-304.</p></li>
                                                <li><p className="further_info_content">Latané, B., Williams,
                                                    K. &amp; Harkins, S. (1979). Many hands make light the work:
                                                    The causes and consequences
                                                    of social loafing. <span className="subtiltereg">Key Readings in Social Psychology,</span> 1,
                                                    297.</p></li>

                                            </ol>

                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page6')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}